<template>
    <a-row type="flex">
        <a-col align="middle" :span="12" :md="24">
            <BadgeProfile :base64Image="base64Image" :countMsg="countMsg" />
            <a-typography-title :level="5">{{ profileData.name }}</a-typography-title>
        </a-col>
        <a-divider class="profile_divider" />
        <a-col :span="24" :md="24">
            <a-tabs v-model:activeKey="activeKey" :tab-position="tabPosition" animated>
                <a-tab-pane key="1" tab="Perfil"><InfoClient :profileData="profileData" /></a-tab-pane>
                <a-tab-pane key="2" tab="Servicios"><ServiceClient /></a-tab-pane>
            </a-tabs>
        </a-col>
    </a-row>
    
</template>
<script>
import BadgeProfile from '@/components/Widgets/BadgeProfile';
import InfoClient from '@/components/login/info_client';
import ServiceClient from '@/components/Services/service_client';
import { defineComponent } from 'vue';
export default defineComponent({
    components: {
        BadgeProfile,
        InfoClient,
        ServiceClient
    },
    props: {
        countMsg: {
            type: Number,
            value: 0
        }
    },
    data() {
        return {
            base64Image: '',
            profileData: null,
            activeKey: "1",
            tabPosition: 'top',
            resizeObserver: null,
            myCliente: null
            // countMsg: 0
        }
    },
    created() {
        this.myCliente = this.$route.meta.myCliente[0];
        this.profileData = this.myCliente;
        this.base64Image = this.myCliente.avatar_512;
        this.refreshCliente();
    },
    mounted() {
        this.initResizeObserver();
    },
    beforeUnmount() {
        this.stopResizeObserver();
    },
    methods: {
        refreshCliente() {
            setInterval(() => {
                if (this.$route.meta.myCliente != undefined &&  JSON.stringify(this.$route.meta.myCliente) !== JSON.stringify(this.profileData)) {
                    this.profileData = this.$route.meta.myCliente[0];
                    this.base64Image = this.profileData.avatar_512
                }
            }, 5000);
        },
        initResizeObserver() {
            this.resizeObserver = new ResizeObserver(this.handleResize);
            // Observar los elementos que necesites
            this.resizeObserver.observe(this.$el);
        },
        stopResizeObserver() {
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
                this.resizeObserver = null;
            }
        },      
        handleResize(entries) {
            // Manejar los cambios de tamaño
            // console.log('Element resized:', entries);
        },
    }
});
</script>
<style>
.clientName {
    margin-top: 15px;
}
.settings-drawer .drawer-content p {
    color: #fff !important;
}
.option_drawer {
    width: 33%;
    display: flex; 
    justify-content: center; 
    align-items: center;
}
.profile_divider {
    height: 2px; 
    background-color: #971fbd; 
    margin-top: 1px; 
    margin-bottom: 1px;
}
</style>